import { post as upload } from './upload'
import { postDoc as uploadDoc } from './upload'
export async function post(
  id: string,
  file: File,
  onUploadProgress?: (progressEvent: any) => void
) {
  return await upload(`/exam/${id}/invigilator/xls`, file, onUploadProgress)
}

export async function postDoc(
  id: string,
  file: File,
  onUploadProgress?: (progressEvent: any) => void
) {
  return await uploadDoc(`/exam/${id}/invigilator/doc`, file, onUploadProgress)
}
